<script setup>

import { defineProps, defineEmits, computed} from "vue";
import UtilMoney from "@/utils/UtilMoney";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "pedidoDeCompra",
]);

//==================================================================//
//============== Valor Disponivel Restante Positivo ================//
//==================================================================//

const valorDisponivelRestantePositivo = computed(()=>{

    return props?.pedidoDeCompra?.valorDisponivelRestante >= 0;

});

//==================================================================//
//===================== Watch Pedido de Compra =====================//
//==================================================================//

</script>

<template>

 <v-card class="c-cartao">

        <v-card-title class="c-cartao__titulo">

            <h3 class="c-titulo">Valores do Pedido {{ props?.pedidoDeCompra?.codigo }}</h3>

        </v-card-title>

        <div class="c-cartao__conteudo">

            <div class="c-campo">

                <v-text-field class="c-campo__input"
                    label="Total dos Itens (Impostos Inclusos)"
                    :value="`R$ ${UtilMoney.toBRL(props?.pedidoDeCompra?.precoTotalComImpostosComIPI)}`"
                    outlined
                    disabled
                    return-object
                ></v-text-field>

            </div>

            <div class="c-campo">

                <v-text-field class="c-campo__input"
                    label="Total dos Itens (Sem Impostos + IPI)"
                    :value="`R$ ${UtilMoney.toBRL(props?.pedidoDeCompra?.precoTotalSemImpostosComIPI)}`"
                    outlined
                    disabled
                    return-object
                ></v-text-field>

            </div>

            <div class="c-campo">

                <v-text-field class="c-campo__input"
                    label="Total do Disponivel"
                    :value="`R$ ${UtilMoney.toBRL(props?.pedidoDeCompra?.valorDisponivel)}`"
                    outlined
                    disabled
                    return-object
                ></v-text-field>

            </div>

            <div class="c-campo">

                <v-text-field class="c-campo__input c-campo__input--total-disponivel-restante-positivo"
                    v-if="valorDisponivelRestantePositivo"
                    label="Total do Disponivel Restante"
                    :value="`R$ ${UtilMoney.toBRL(props?.pedidoDeCompra?.valorDisponivelRestante)}`"
                    outlined
                    disabled
                    return-object
                ></v-text-field>

                <v-text-field class="c-campo__input c-campo__input--total-disponivel-restante-negativo"
                    v-else
                    label="Total do Disponivel Restante"
                    :value="`R$ ${UtilMoney.toBRL(props?.pedidoDeCompra?.valorDisponivelRestante)}`"
                    outlined
                    disabled
                    return-object
                ></v-text-field>

            </div>

        </div>

    </v-card>

</template>

<style scoped>


.c-cartao__titulo{
    display: grid; 
    grid-template-columns: 1fr; 
    grid-template-rows: 1fr; 
    gap: 10px; 
    grid-template-areas: 
        "titulo";
}

.c-titulo {
    grid-area: titulo;
}

.c-cartao__conteudo{
    display: grid;
    grid-auto-flow: row;
}

.c-campo__input.v-input--is-disabled >>> label{
    color: rgba(0, 0, 0, 0.54) !important;
}

.c-campo__input.v-input--is-disabled >>> input{
    color: rgba(0, 0, 0, 0.54) !important;
}

.c-campo__input--total-disponivel-restante-negativo.v-text-field--outlined >>> fieldset {
    border: 2px solid rgba(255, 0, 0, 1);
}

.c-campo__input--total-disponivel-restante-positivo.v-text-field--outlined >>> fieldset {
    border: 2px solid rgb(0, 150, 0);
}

</style>